import { DateTimeService } from "../../../services/date-time-service"
import { useDateFormat } from "../../../users/hooks/use-date-format"
import { ProjectDashboardViewModel } from "../../api/project-dashboard"

export const useFormatSchedule = (projectDashboard: ProjectDashboardViewModel) => {
  const { dateFormat } = useDateFormat()
  const dateTimeService = new DateTimeService({
    dateFormat,
    timeZone: projectDashboard?.timeZone,
    enableTimeComponent: projectDashboard?.enableTimeComponent,
  })

  const formattedPlannedStart = projectDashboard?.plannedStartDate
    ? dateTimeService.format(projectDashboard.plannedStartDate)
    : ""
  const formattedPlannedEnd = projectDashboard?.plannedEndDate
    ? dateTimeService.format(projectDashboard.plannedEndDate)
    : ""
  const formattedActualStart = projectDashboard?.actualStartDate
    ? dateTimeService.format(projectDashboard.actualStartDate)
    : ""
  const formattedActualEnd = projectDashboard?.actualEndDate
    ? dateTimeService.format(projectDashboard.actualEndDate)
    : ""
  const formattedRejectedDate = projectDashboard?.rejectedDate
    ? dateTimeService.format(projectDashboard.rejectedDate)
    : ""

  return {
    formattedPlannedStart,
    formattedPlannedEnd,
    formattedActualStart,
    formattedActualEnd,
    formattedRejectedDate,
  }
}
